// Revenue in the store's own QuickBooks that never became an Admin order, for
// the last closed month. Served by api-v2, which accepts the legacy staff token.
//
// Plain fetch — NOT axios — for the same reason uploadViaPresign PUTs with fetch:
// the shared axios response interceptor (Services/Interceptors/Interceptors.jsx)
// redirects to /login on any 401, so a cosmetic tile on the global client would
// log the admin out on dashboard load.
import Cookies from "universal-cookie";
import { API_V2_URL } from "./apiUrl";

export async function getOtherRevenue(storeId) {
  if (!Number(storeId)) return null;
  try {
    const response = await fetch(
      `${API_V2_URL}/api/revenue/other?store_id=${Number(storeId)}`,
      { headers: { authorization: new Cookies().get("accessToken") || "" } }
    );
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
}
